<template>
  <div class="item-manage">
    <el-row>
      <el-col :span="24">
        <el-tabs type="border-card" v-model="currentTab">
          <el-tab-pane label="引导关注" name="first">
            <item_list></item_list>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>

</template>
<script>
export default {
  name: "index",
  components: {
    item_list: require('./item_list').default,

  },
  watch: {},
  computed: {},

  created() {

  },
  mounted() {

  },
  data() {
    return {
      currentTab: 'first',
      activeNames: ['1'],
    }
  },
  methods: {}
}

</script>
<style lang="scss">

.user-manage {
  text-align: left;

  .inline {
    display: inline;
    margin-right: 10px;

    .el-input__inner {
      width: 150px;
    }
  }


  .grid-content {
    padding: 10px;
  }

  .title {
    margin-left: 10px;
    display: flex;
    align-items: center;

    .trigger {
      margin-left: 20px;
    }

    strong {
      color: $hover-color;
    }

  }
}

</style>